




























import Vue from "vue";
import moment, { unitOfTime } from "moment";
import Utils from "@/utils";
import i18n from "./../../plugins/i18n";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../dialogs/ZenyaDialog.vue";
import { Comment } from "@/documentComments";
import { CommentReply } from "@/types/commentReply";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "DocumentComments",
    props: {
        comments: Array as () => Comment[]
    },
    data: function () {
        return {};
    },
    components: {},
    computed: {},
    async created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: null, cancel: null });
    },
    methods: {
        getCommentDateString(comment: Comment): string {
            moment.locale(i18n.locale);

            if (!moment(comment.created_datetime).isSame(moment(), "year")) {
                if (i18n.locale === "nl") return moment(comment.created_datetime).format("D MMM YY").replace(".", "");
                else return moment(comment.created_datetime).format("D MMM YY");
            }

            let date = Utils.formatDateToCalendar(comment.created_datetime);

            if (i18n.locale === "nl") return date.replace(".", "");
            else return date;
        },
        getCommentStatus(comment: Comment): string {
            switch (comment.state) {
                case "new":
                    return this.$t("comment.state.new") as string;
                    break;
                case "accepted":
                    return this.$t("comment.state.accepted") as string;
                    break;
                case "fixed":
                    return this.$t("comment.state.fixed") as string;
                    break;
                case "rejected":
                    return this.$t("comment.state.rejected") as string;
                    break;
                default:
                    return "";
            }
        }
    }
});
